// extracted by mini-css-extract-plugin
export default {"button":"SettingsSidebar_button__w5NiE","drawer":"SettingsSidebar_drawer__aMjoa"};